.row {
  font-family: inherit;
  font-size: inherit;
}
